import _ from "lodash";
import React, { ReactElement } from "react";
import { Table } from "react-bootstrap";
import { Lead } from "../Lead";
import { EmailUploadValidator } from "./UploadEmailValidator";

interface IProps {
	leads: Lead[];
}

export const UploadPreview = (props: IProps): ReactElement => {
	return (
		<Table>
			<thead>
				<tr>
					<td>First name</td>
					<td>Last name</td>
					<td>Email</td>
					<td>Valid?</td>
				</tr>
			</thead>
			{props.leads.map((lead: Lead) => {
				return (
					<tr>
						<td>{lead.firstName}</td>
						<td>{lead.lastName}</td>
						<td>{lead.email}</td>
						<td>
							<EmailUploadValidator email={lead.email} />
						</td>
					</tr>
				);
			})}
		</Table>
	);
};
